import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { DropdownSvg } from "../../../svgFiles/DropdownSvg";
import useTranslator from "../../../hooks/useTranslator";
const MultiSelect = ({ options, selectedData, onChange }) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedData || {});

  const { _t } = useTranslator();
  
  useEffect(() => {
    setSelectedOptions(selectedData);
  }, [selectedData]); // Sync with parent state when it changes

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) => {
      const newState = { ...prev };

      if (option in newState) {
        delete newState[option]; // Remove unchecked option
      } else {
        newState[option] = ""; // Set to "0" or empty string if needed
      }

      // Delay the update to onChange to after render
      setTimeout(() => {
        onChange(newState);
      });

      return newState;
    });
  };

  const handleInputChange = (option, value) => {
    setSelectedOptions((prev) => {
      const newState = { ...prev, [option]: value };
      // Delay the update to onChange to after render
      setTimeout(() => {
        onChange(newState);
      });

      return newState;
    });
  };

  const getType = (type) => {
    if (type === "seconds") return "Seconds KG";
    if (type === "humidity") return "Humidity Kg";
    if (type === "green") return "Green Kg";
    if (type === "bone_seed") return "Bone/Seed Kg";
    if (type === "toasted") return "Toasted";
    if (type === "strange_material") return "Foreign Material";
    if (type === "tapita") return "Tapita";
    if (type === "pieces") return "Pieces";
    return "Spot";
  };

  return (
    <div>
      <label>{_t('other','Other')}</label>
      <Dropdown className="custom_multiselect">
        <Dropdown.Toggle id="dropdown-basic">
          {Object.keys(selectedOptions).length > 0
            ? Object.entries(selectedOptions)
                .map(([key, value]) => `${getType(key)} (${value || 0})`)
                .join(", ")
            : _t("select_type","Select Type")}
          {DropdownSvg}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {options.map((option) => (
            <li key={option.value} className="dropdown_item">
              <label>
                <input
                  type="checkbox"
                  checked={option.value in selectedOptions}
                  onChange={() => handleCheckboxChange(option.value)}
                />
                {option.label}
              </label>
              <input
                className="number_select"
                type="number"
                min="0"
                value={selectedOptions[option.value] || ""}
                onChange={(e) =>
                  handleInputChange(option.value, e.target.value)
                }
                placeholder="0"
                disabled={!(option.value in selectedOptions)}
                required={option.value in selectedOptions} // Only required if checked
              />
            </li>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MultiSelect;
